function equalize() {
  const mains = document.querySelectorAll('.section--stack__main');
  // Reset przed pomiarem
  mains.forEach(el => el.style.height = '');

  // Wyrównaj duże kafle
  if (mains.length) {
    const maxMain = Math.max(...[...mains].map(el => el.offsetHeight));
    mains.forEach(el => el.style.height = maxMain + 'px');
  }
}

equalize();
window.addEventListener('resize', equalize);
